module.exports = "/_next/static/images/AdaptImage@2x-2033d98b08153b3c597c3b75319bb05f.png";